import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { PreplacementTrainingRoutingModule } from './preplacement-training-routing.module';
import { PreplacementTrainingListComponent } from './preplacement-training-list/preplacement-training-list.component';
import { PreplacementTrainingCreateComponent } from './preplacement-training-create/preplacement-training-create.component';

@NgModule({
  declarations: [PreplacementTrainingListComponent, PreplacementTrainingCreateComponent],
  imports: [
    CommonModule,
    PreplacementTrainingRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class PreplacementTrainingModule { }
